module.exports = __webpack_public_path__ + "img/E282.435b6aaa.svg";